import { makeAutoObservable } from 'mobx';
import IFilterSettings from '../interfaces/IFilterSettings';
import LocalStorageService from '../services/localStorageService';
import { fillMissingFilters, getDefaultFilters, getDefaultLeaseCompFilters, getDefaultSaleCompFilters, getDefaultTenantInMarketFilters } from '../utils/filterSettingsUtils';

export default class FilterSettingsStore {
    defaultFilters: IFilterSettings;
    filters: IFilterSettings;
    isOpen: boolean;
    tab: GlobalFiltersTab;

    constructor(
        private localStorageService: LocalStorageService,
    ) {
        makeAutoObservable(this);

        this.defaultFilters = localStorageService.getDefaultFilters() || getDefaultFilters();
        if (!this.defaultFilters.leaseCompSettings || !this.defaultFilters.saleCompSettings || !this.defaultFilters.tenantInMarketSettings) { // old version of filters
            this.defaultFilters = {
                ...this.defaultFilters,
                leaseCompSettings: getDefaultLeaseCompFilters(),
                saleCompSettings: getDefaultSaleCompFilters(),
                tenantInMarketSettings: getDefaultTenantInMarketFilters(),
            };
        }
        this.defaultFilters.tenantInMarketSettings = { ...getDefaultTenantInMarketFilters(), ...this.defaultFilters.tenantInMarketSettings };
        fillMissingFilters(this.defaultFilters);

        this.filters = { ...this.defaultFilters };
        this.isOpen = false;
        this.tab = GlobalFiltersTab.Deals;
    }

    setDefaultFilters(value: IFilterSettings) {
        this.defaultFilters = value;
        this.filters = { ...value };
        this.localStorageService.setDefaultFilters(value);
    }

    setFilters(value: IFilterSettings) {
        this.filters = fillMissingFilters(value);
    }

    open(tab?: GlobalFiltersTab) {
        this.isOpen = true;
        if (tab !== undefined)
            this.tab = tab;
    }

    close() {
        this.isOpen = false;
    }
}

export enum GlobalFiltersTab {
    Deals,
    Leads,
    LeaseComps,
    SaleComps,
    TIMs,
    Companies,
}